<template>
	<div class="tooltip">
		<el-tooltip 
		effect="light"
		placement="top"
		:hide-after="0"
		popper-class="tableTip"
		>
			<div slot="content">
				<div class="bm tipBox" style="color:#323232;font-size: 12px">
					<div class="bm row bm-ac" >
						<span v-html="message.tipInfo"></span>
					</div>
				</div>
			</div>
			<img src="../../asserts/img/ico_problem.png"/>
		</el-tooltip>
	</div> 
</template>
<script>
export default {
	name:"testDialog",
	props:{
		message:{
			type:Object,
			default(){
				return {};
			}
		}
	},
	data(){
		return{
			timeLong:0,
			visible:true
		}
	}
}
</script>

<style lang="scss">
.tooltip{
	/deep/.tipBox{
		background-color: #fed11b;
		color:#323232;
		font-size: 12px;
	}
}
</style>
